import React from "react";
import {
    Box,
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import PlayerRow from "./PlayerRow";

const PlayersTable = ({ players, showAll, limit, onToggleShowAll, onOpenModal }) => (
    <>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Steam ID</TableCell>
                        <TableCell>Игрок</TableCell>
                        <TableCell>Часы</TableCell>
                        <TableCell>Был в игре</TableCell>
                        <TableCell align="right">Действия</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(showAll ? players : players.slice(0, limit)).map((player) => (
                        <PlayerRow key={player.steam_id} player={player} onOpenModal={onOpenModal} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        {players.length > limit && (
            <Box display="flex" justifyContent="center" mt={2}>
                <Button variant="outlined" size="small" onClick={onToggleShowAll}>
                    {showAll ? "Свернуть до 50 игроков" : `Показать всех (${players.length})`}
                </Button>
            </Box>
        )}
    </>
);

export default PlayersTable;
